"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const poto_png_1 = __importDefault(require("../../assets/poto.png"));
const chatEvents_1 = __importDefault(require("../../lib/chatEvents"));
const configureStore_1 = require("../../store/configureStore");
const SendPoto = ({ socket }) => {
    const { room, imageSize, handleIsModal, handleModalContents } = (0, react_1.useContext)(configureStore_1.StoreContext);
    const openModal = (message) => {
        handleModalContents(react_1.default.createElement("h3", { style: {
                width: "80%",
                margin: "0 auto",
                textAlign: "center",
                fontSize: "1rem",
                color: "rgb(94 22 22)",
            } }, message));
        handleIsModal(true);
    };
    const handleFile = (e) => {
        const file = e.target.files;
        if (file !== null) {
            const Events = new chatEvents_1.default(socket);
            const MB = 1024 * 1024;
            const result = Events.sendImage(file[0], room, imageSize * MB);
            if (!result) {
                openModal(`${imageSize}MB 이하의 이미지 파일만 전송 할 수 있습니다.`);
            }
        }
        e.target.value = '';
    };
    return (react_1.default.createElement("label", { style: {
            display: "flex",
            marginRight: "3px"
        } },
        react_1.default.createElement("img", { src: poto_png_1.default, width: "30px" }),
        react_1.default.createElement("input", { type: "file", style: {
                display: "none"
            }, onChange: handleFile, accept: "image/*" })));
};
exports.default = SendPoto;
